"use client";

import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";
import { FixedTop } from "../FixedTop";
import { MenuDock } from '../Menu';

export default function MainLayout(props: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setIsLoading(false);
          return 100;
        }
        return prev + 1;
      });
    }, 15);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    function listen(event: any) {
      const target = event.target.closest(
        'div[data-action],a[data-action],button[data-action],li[data-action]',
      );

      if (!target) {
        return;
      }

      const action = target.dataset.action;
      if (!action) {
        return;
      }
      console.debug('action', action);
      ReactGA.event({
        category: 'action',
        action: action,
      });
    }

    document.addEventListener('click', listen);

    return () => document.removeEventListener('click', listen);
  }, []);


  if (isLoading) {
    return (
      <div className="h-screen w-screen bg-desktop bg-[center_50%] bg-no-repeat bg-cover overflow-hidden">
        <div className="absolute inset-0 z-50 flex flex-col items-center justify-center h-screen w-screen">
          <div className="absolute inset-0 bg-black/30 backdrop-blur-xl"></div>

          <div
            className="absolute bg-desktop bg-[center_50%] bg-no-repeat bg-cover h-screen w-screen mask-holdstation"

          ></div>

          <div className="absolute top-[56%] w-44 bg-white/30 rounded-[4px] h-[6px] z-10">
            <div
              className="bg-white h-[6px] rounded-[90px] transition-all duration-100"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className="relative w-screen h-screen overflow-y-auto overflow-x-hidden z-30 bg-black">
      <FixedTop />
      <main className="relative h-full z-10">
        {props.children}
        <div className="pb-36 w-full"></div>
        <div className="hidden md:flex pb-4 mx-4 justify-end relative z-20">
          <div className="w-full md:w-fit flex justify-center items-center gap-6">
            <p className="text-xs leading-[40px] font-medium text-white">
              <Link to="/terms">Term and service</Link>
            </p>
            <p className="text-xs leading-[40px] font-medium  text-white">
              <Link to="/policy">Privacy policy</Link>
            </p>
          </div>
        </div>
      </main>

      <MenuDock />
    </div>
  );
}
